import { randomBytes } from 'node:crypto';

export function generateShortcutToken(): string {
  return randomBytes(32).toString('base64url');
}
